import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url ?? '';
      // Endpoints that have no session to lose. Signing in obviously, but also
      // anything under /public — a 401 there means the KEY in the URL was
      // wrong, not that a session expired. Redirecting would send the wallboard
      // on the office wall to a login page nobody is standing at, and it would
      // sit there until somebody noticed.
      const isUnauthenticatedEndpoint = url.includes('/auth/') || url.includes('/public/');
      if (!isUnauthenticatedEndpoint) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
